<template>
	<div class="container-fluid" v-if="vendor">
		<div class="row">
			<div class="col-8 offset-2">

				<!--Breadcrumb-->
				<nav style="--bs-breadcrumb-divider: '>';  font-size: 35px;" aria-label="breadcrumb">
					<ol class="breadcrumb py-0 pt-3 container bg-light">

						<li class="breadcrumb-item pl-2 pr-2">
							<router-link to="/dn/v2">Wareneingang</router-link>
						</li>
						<li v-if="this.$route.params.vendorId > 0" class="breadcrumb-item pl-2 pr-2" aria-current="page">
							{{ vendor.name }}
						</li>
						<li v-else-if="this.$route.params.vendorId == -1" class="breadcrumb-item pl-2 pr-2" aria-current="page">Alle
							Händler
						</li>
						<li v-else class="breadcrumb-item pl-2 pr-2" aria-current="page">ERROR</li>
					</ol>
				</nav>
			</div>
		</div>
		<div class="row">
			<div class="col-2">
				<!-- Filter Fenster-->
				<div class="card">
					<div class="card-body">
						<h5 class="card-title">Filter</h5>
						<div class="input-group rounded  pb-3">
							<input type="search" class="form-control rounded" placeholder="z.B Rechnungsnummer" aria-label="Search"
										 aria-describedby="search-addon" v-model="filter" @change="applyFilter"
										 @keydown.enter="applyFilter"/>
						</div>
						<b-form-checkbox
								v-if="this.$route.params.vendorId == -1"
								v-model="isEan"
								:value="true"
								:unchecked-value="false"
						>
							Ean Suche
						</b-form-checkbox>
						<!--Buttons-->
						<h5 class="card-title pt-3">Aktionen</h5>
						<button @click="switchPackageArrived(1)" class="btn btn-success mb-2 btn-block"
										:disabled="selectedDelieryNotes.length == 0">
							{{ selectedDelieryNotes.length }} x Freigeben
						</button>
						<button @click="switchPackageArrived(-1)" class="btn btn-primary mb-2 btn-block"
										:disabled="selectedDelieryNotes.length == 0">
							{{ selectedDelieryNotes.length }} x Umschalten
						</button>
						<button @click="switchPackageArrived(0)" class="btn btn-danger mb-2 btn-block"
										:disabled="selectedDelieryNotes.length == 0">
							{{ selectedDelieryNotes.length }} x Sperren
						</button>
						<div>
							<b-button href="#" class="btn btn-secondary mt-2 btn-block" @click="showModalForSelection()"
												:disabled="selectedDelieryNotes.length == 0">
								{{ selectedDelieryNotes.length }} x Tracking einfügen
							</b-button>
							<b-modal centered id="add-tracking-modal" title="Trackingnummer hinzufügen" no-close-on-backdrop
											 v-model="showModal"
											 @hidden="resetModal" @ok="saveTracking">
								<b-form-select v-model="trackingPayload.shippingServiceId" :options="shippingServiceOptions"
															 text-field="name" value-field="id" class="mb-3"></b-form-select>
								<b-form-input placeholder="Trackingnummer" v-model="trackingPayload.trackingNumber"
															text-center></b-form-input>
							</b-modal>
						</div>
					</div>
				</div>

			</div>

			<!-- Wareneingang Seite1 Lieferanten-->

			<div class="col-8">
				<div class="card">
					<div class="card-body">

						<div class="d-flex justify-content-between">
							<b-form-group>
								<b-form-radio-group
										id="btn-radios-amount"
										v-model="perPage"
										:options="amountOptions"
										name="radios-btn-default"
										button-variant="outline-secondary"
										size="lg"
										buttons
								></b-form-radio-group>
							</b-form-group>

							<h4 v-if="this.$route.params.vendorId != -1">
								letztes Lieferschein Datum: {{ lastDeliveryDate }}
							</h4>

							<b-pagination
									v-model="currentPage"
									:total-rows="filteredDeliveryNotes.length"
									:per-page="perPage"
							></b-pagination>

						</div>

						<b-table striped hover
										 :items="filteredDeliveryNotes"
										 :fields="visibleFields"
										 :per-page="perPage"
										 :current-page="currentPage"
										 class="mikasmallz table"
										 sort-by="date"
										 :sortDesc="descendDate"
										 :tbody-tr-class="rowClass"
						>

							<template #cell(number)="data">
								<span v-if="data.item.dateCompleted == null">
										<router-link :to="'/dn/v2/vendor/' + data.item.vendorId + '/dn/' + data.item.id">{{
												data.item.number ? data.item.number : "Unknown"
											}}</router-link>
								</span>
								<span v-else>
									{{data.item.number ? data.item.number : "Unknown" }}
								</span>
							</template>

							<template #head(_isSelected)>

								<b-form-checkbox
										:checked="allSelected"
										:value="true"
										:unchecked-value="false"
										@change="processCheckAllSelections"
								>
								</b-form-checkbox>

							</template>

							<template #cell(_isSelected)="data">

								<b-form-checkbox
										v-model="data.item._isSelected"
										@click="processCheckAllSelections"
										:value="true"
										:unchecked-value="false"
								>
									<b-badge :variant="getLabelVariant(data.item)">
										{{ getLabelText(data.item) }}
									</b-badge>
								</b-form-checkbox>

							</template>

							<template #cell(vendorId)="data">
								{{ vendorIdFormatter(data.item.vendorId) }}
							</template>


							<template #cell(delivery_note_positions_sum_quantity)="data">
								{{ data.item.delivery_note_positions_sum_quantity }}
							</template>

							<template #cell(date)="data">
								{{  this.$route.params.vendorId > 0 ?  moment(data.value).locale('de').format('dd DD.MM.YYYY HH:mm') : moment(data.value).format('DD.MM.YYYY HH:mm') }}
							</template>

							<template #cell(trackingNumber)="data">
								<span v-for="trackinginfo in data.item.deliverynotetrackinginfos"
											v-bind:key="trackinginfo.id" class="mr-1">
										<a :href="getTrackingLink(trackinginfo)" target="_blank">{{
												trackinginfo.trackingNumber
											}} </a>
										<a v-if="trackinginfo.id > 0" class="clickable ml-1"
											 @click="deleteTrackingModal.show = true; deleteTrackingModal.selectedTracking = trackinginfo;">
												<i class="bi bi-x-square"></i>
										</a>
								</span>
								<a class="clickable" @click="showModalForDN(data.item)">
									<i class="bi bi-plus-square"></i>
								</a>

							</template>

							<template #cell(action)="data">
								<b-dropdown size="sm" variant="outline-secondary" text="Aktionen">
									<b-dropdown-item @click="openImageDownloadModal(data.item)">
										Fotos herunterladen <b-spinner  v-if="imageDownloadLoading" small class="mr-2"></b-spinner>
									</b-dropdown-item>
								</b-dropdown>
							</template>

						</b-table>

						<b-modal centered id="delete-tracking-modal" title="Tracking löschen" no-close-on-backdrop
										 v-model="deleteTrackingModal.show" @ok="deleteTracking(deleteTrackingModal.selectedTracking)">
							<h5 class="mb-4 mt-4 text-center" v-if="deleteTrackingModal.selectedTracking"> Sind sie sicher, dass sie
								das Tracking <a :href="getTrackingLink(deleteTrackingModal.selectedTracking)"
																target="_blank">{{ deleteTrackingModal.selectedTracking.trackingNumber }} </a>löschen
								wollen?</h5>
							<template #modal-footer="{ ok, cancel }">
								<b-button type=button lass="btn-secondary" @click="cancel()">Abbrechen</b-button>
								<b-button type="button" class="btn-danger" @click="ok()">Löschen</b-button>

							</template>
						</b-modal>


					</div>
				</div>
			</div>

			<div class="col-2">
				<div v-if="$route.params.vendorId > 0" class="card">
					<div class="card-body">
						<h5 class="card-title pb-2">Listen</h5>
						<router-link :to="'/dn/v2/vendor/' + vendor.id + '/dn/-1'" class="btn btn-secondary mt-2 btn-block">
							Gesamtübersicht
						</router-link>
						<router-link :to="'/dn/v2/vendor/' + vendor.id + '/dn/-2'" class="btn btn-secondary mt-2 btn-block">
							Gesamtübersicht freigegeben
						</router-link>
						<router-link :to="'/dn/v2/vendor/' + vendor.id + '/dn/-3'" class="btn btn-secondary mt-2 btn-block">
							Gesamtübersicht 3 Monate
						</router-link>
						<router-link :to="'/dn/v2/vendor/' + vendor.id + '/claims'" class="btn btn-primary mt-2 btn-block">
							<b-icon icon="bootstrap-reboot" font-scale="1" class="mr-2"></b-icon>
							Reklamationen
						</router-link>
					</div>
				</div>
			</div>
			<modal-error-component v-model="modalError"></modal-error-component>

		</div>
	</div>
</template>
<script>

import QrcodeVue from "qrcode.vue";

export default {
	components: {QrcodeVue},
	data() {
		return {
			currentPage: 1,
			perPage: 25,
			amountOptions: [10, 25, 50],
			filter: '',
			isEan: false,
			filteredDeliveryNoteIds: [], // for ean search
			vendor: null,
			deliveryNotes: [],
			filteredDeliveryNotes: [],
			lastDeliveryDate: '',
			fields: [
				{key: "_isSelected", label: ' ', visible: true},
				{key: 'number', label: "LS-Nummer", visible: true},
				{key: 'vendorId', label: 'Händler', visible: this.$route.params.vendorId < 0},
				{key: 'delivery_note_positions_sum_quantity', label: "Stückzahl", visible: this.$route.params.vendorId > 0, },
				{key: 'fileName', label: "Datei Name", visible: true},
				{key: 'date', label: "Datum", visible: true, sortable: true},
				{key: 'trackingNumber', label: "Trackingnummer", visible: true},
				{key: 'action', label: "", visible: true}
			],
			selectedShippingService: null,
			shippingServiceOptions: [],
			showModal: false,
			deleteTrackingModal: {
				show: false,
				selectedTracking: null,
			},
			queryInProgress: false,
			nextDummyId: -1,
			trackingPayload: {
				trackingNumber: null,
				shippingServiceId: null,
				idsForTracking: [],
				goal: null
			},
			selectedDeliveryNote: null,
			imageDownloadLoading: false,
			showQRCodeModal: false,
			qrCodeString: "",
			hasReturnImages: false,
			modalError: {
				show: false,
				message: "unpopulated",
				error: "unpopulated",
				title: "unpopulated"
			},
		}
	},
	created() {
		if (this.$route.params.vendorId > 0) {
			Promise.all([
				axios.get("/vendor/" + this.$route.params.vendorId + "/fetch"),
				axios.get("/deliverynote/" + this.$route.params.vendorId + "/fetch_with_completed"),
				axios.get("/shipping_service/all"),
				axios.get("/deliverynote/" + this.$route.params.vendorId + "/date"),
			]).then(responses => {
				this.vendor = responses[0].data;
				this.deliveryNotes = responses[1].data.map(deliveryNote => {
					deliveryNote._isSelected = false;
					return deliveryNote;
				});
				this.filteredDeliveryNotes = this.deliveryNotes;
				this.shippingServiceOptions = responses[2].data;
				this.lastDeliveryDate = responses[3].data ? moment(responses[3].data).format('DD.MM.YYYY') : '';
			})
		} else {
			Promise.all([
				axios.get("/vendor/all_names"),
				axios.get("/deliverynote/fetch_all"),
				axios.get("/shipping_service/all"),
			]).then(responses => {
				this.vendor = responses[0].data;
				this.deliveryNotes = responses[1].data.map(deliveryNote => {
					deliveryNote._isSelected = false;
					return deliveryNote;
				});
				this.filteredDeliveryNotes = this.deliveryNotes;
				this.shippingServiceOptions = responses[2].data;

			})
		}
	},
	watch: {
		filter: {
			immediate: true,
			handler() {
				this.applyFilter();
			}
		},
		isEan: {
			immediate: true,
			handler() {
				if( this.isEan ) {
					this.applyFilter();
				} else {
					this.filteredDeliveryNotes = this.deliveryNotes;
					this.filteredDeliveryNoteIds = [];
					this.applyFilter();
				}
			}
		},
	},
	computed: {
		selectedDelieryNotes() {
			return this.filteredDeliveryNotes.filter(deliveryNote => deliveryNote._isSelected);
		},
		allSelected() {
			return (this.filteredDeliveryNotes.length == this.selectedDelieryNotes.length);
		},
		descendDate() {
			if (parseInt(this.$route.params.vendorId) < 0) {
				return false;
			} else {
				return true;
			}
		},
		visibleFields() {
			return this.fields.filter(field => field.visible)
		}
	},
	methods: {
		log(value) {
			console.log(value);
			return value;
		},
		async applyFilter() {
			if (this.queryInProgress == true || (this.deliveryNotes.length == 0 && this.filteredDeliveryNotes.lenght == 0)) return;
			if (!this.filter || this.filter.trim().length < 1) {
				this.filteredDeliveryNotes = this.deliveryNotes;
				return;
			}
			if (this.isEan) {
				console.log("EAN Suche");
				if (!this.filter.trim() || this.filter.trim().length < 1) return [];
				this.queryInProgress = true;
				axios.get("/deliverynote/" + this.filter.trim())
						.then(res => {
							this.queryInProgress = false;
							this.filteredDeliveryNoteIds = res.data
							if (!this.filteredDeliveryNoteIds || this.filteredDeliveryNoteIds.length === 0) {
								this.filteredDeliveryNotes = [];
								return;
							}
							console.log("Ids found: " + this.filteredDeliveryNoteIds);
							this.filteredDeliveryNotes = this.deliveryNotes.filter(
									deliveryNote => this.filteredDeliveryNoteIds.includes(deliveryNote.id)
							);
						})
						.catch(error => {
							this.queryInProgress = false;
							this.modalError = {
								show: true,
								message: "Ein Fehler bei der EAN Suche ist aufgetreten",
								error: error,
								title: "EAN SucheFehler"
							};
							console.error(error)
						})
			} else {
				console.log("Normal Suche");
				this.filteredDeliveryNotes = this.deliveryNotes.filter(
						deliveryNote => deliveryNote.number.includes(this.filter.trim())
				);
			}
		},
		showModalForSelection() {
			this.showModal = true;
			this.trackingPayload.idsForTracking = this.selectedDelieryNotes.map(deliveryNote => deliveryNote.id);
		},
		showModalForDN(deliveryNote) {
			this.showModal = true;
			this.trackingPayload.idsForTracking = [deliveryNote.id];
		},
		resetModal() {
			this.trackingPayload.shippingServiceId = null;
			this.trackingPayload.trackingNumber = null;
			this.trackingPayload.idsForTracking = [];
			this.nextDummyId--;
		},
		saveTracking(bvModalEvent) {
			bvModalEvent.preventDefault()
			if (this.queryInProgress == true) return;
			this.queryInProgress = true;
			axios.post('/deliverynote/add/tracking/bulk', this.trackingPayload).then(() => {
				this.trackingPayload.idsForTracking.forEach((id) => {
					this.trackingPayload.id = this.nextDummyId;
					this.nextDummyId--;
					let dn = this.deliveryNotes.filter((deliveryNote) => deliveryNote.id == id).at(0);
					if (!dn.deliverynotetrackinginfos) dn.deliverynotetrackinginfos = [];
					dn.deliverynotetrackinginfos.push(_.cloneDeep(this.trackingPayload));
				})
				this.showModal = false;
				this.queryInProgress = false;
			}).catch((error) => {
				console.log(error)
			})
		},
		deleteTracking(tracking) {
			axios.delete("/deliverynote/tracking/" + tracking.id)
					.then(response => {
						if (response.status >= 200 && response.status <= 226) {

							/*
	for (let dn of this.deliveryNotes) {
		if (dn.deliverynotetrackinginfos.find(trk => trk.id == tracking.id)) {
			_.remove(dn.deliverynotetrackinginfos, trk => trk.id == tracking.id);
		}
	}*/
							location.reload();
						} else {
							console.log(response);
							let error = "status: " + response.status + "\n";
							error += "response: \n" + JSON.stringify(response, null, 2);

							this.modalError = {
								show: true,
								message: "Tracking konnte nicht gelöscht werden.",
								error: error,
								title: "Delete Tracking"
							};
						}
					})
					.catch(err => {
						console.log(err);
						this.modalError = {
							show: true,
							message: "Tracking konnte nicht gelöscht werden.",
							error: err,
							title: "Delete Tracking"
						};
					});
		},
		getTrackingLink(trackinginfo) {
			let url = this.shippingServiceOptions.find((shippingService) => shippingService.id == trackinginfo.shippingServiceId).url;
			if (url == null) return "#";
			return url.replace("%IDENTIFIER%", trackinginfo.trackingNumber);
		},
		switchPackageArrived(goal) {
			axios.post('/deliverynote/switch/packagearrived/bulk', {
				ids: this.selectedDelieryNotes.map(dn => dn.id),
				goal
			}).then(() => {
				this.selectedDelieryNotes.forEach((dn) => {
					dn.packageArrived = ((goal == -1) ? (!dn.packageArrived) : goal);
					this.uncheckAlldeliveryNotes();
				})
			}).catch((error) => {
				console.log(error)
				this.modalError = {
					show: true,
					message: "Ein Fehler ist aufgetreten",
					error: error.response.data ? error.response.data.message : error,
					title: "Switch Package Arrived"
				};
			})
		},
		uncheckAlldeliveryNotes() {
			this.deliveryNotes = this.deliveryNotes.map(claim => {
				claim._isSelected = false;
				return claim
			})
		},
		processCheckAllSelections() {

			let inv = !this.allSelected;
			this.filteredDeliveryNotes.forEach(dn => dn._isSelected = inv)
			/*
			<=> Equivalent
			if(this.allSelected)
			{
					this.filteredDeliveryNotes.forEach(dn => dn._isSelected = false )
			}
			else
			{
					this.filteredDeliveryNotes.forEach(dn => dn._isSelected = true )
			}*/
		},
		vendorIdFormatter(vendorId) {
			if (!vendorId) return "-";
			try {
				return this.vendor.find(vendor => vendor.id == vendorId).name;
			} catch (e) {
				return "-"
			}
		},
		rowClass(item) {
			return item.dateCompleted !== null ? 'gray-out' : '';
		},
		getLabelVariant(deliveryNote) {
			if(deliveryNote.dateCompleted){
				return 'primary';
			} else if(!deliveryNote.packageArrived) {
				return 'danger';
			} else {
				return 'success';
			}
		},
		getLabelText(deliveryNote) {
			if(deliveryNote.dateCompleted){
				return 'Abgeschlossen';
			} else if(!deliveryNote.packageArrived) {
				return 'Gesperrt';
			} else {
				return 'Freigegeben';
			}
		},
		openImageDownloadModal(item) {
			this.selectedDeliveryNote = item;
			this.imageDownloadLoading = true;
			axios.get("/deliverynote/" + this.selectedDeliveryNote.id + "/returnimages/exists")
				.then(response => {
					this.hasReturnImages = response.data;
					if (this.hasReturnImages) {
						this.downloadReturnImages(this.selectedDeliveryNote.id);
					} else {
					  this.imageDownloadLoading = false;
						this.modalError = {
							show: true,
							message: "Für diesen Lieferschein sind keine Rücksendebilder vorhanden.",
							error: null,
							title: "Rücksendebilder"
						};
					}
				})
				.catch(error => {
					console.error("Fehler beim Überprüfen der Rücksendebilder:", error);
					this.modalError = {
						show: true,
						message: "Fehler beim Überprüfen der Rücksendebilder",
						error: error,
						title: "Rücksendebilder"
					};
					this.imageDownloadLoading = false;
				});
		},
		downloadReturnImages(deliveryNoteId) {
			axios.get(`/deliverynote/${deliveryNoteId}/returnimages/download`)
					.then((response) => {
						const images = response.data;
						images.forEach((b64Data, index) => {
							// Convert raw base64 to a Blob
							const byteCharacters = atob(b64Data);
							const byteNumbers = new Array(byteCharacters.length);

							for (let i = 0; i < byteCharacters.length; i++) {
								byteNumbers[i] = byteCharacters.charCodeAt(i);
							}

							const byteArray = new Uint8Array(byteNumbers);
							const blob = new Blob([byteArray], { type: 'image/jpeg' });

							this.imageDownloadLoading = false;

							// Trigger download
							const url = window.URL.createObjectURL(blob);
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', `LF-Return_${index + 1}_${deliveryNoteId}.jpg`);

							document.body.appendChild(link);
							link.click();

							// Cleanup
							document.body.removeChild(link);
							window.URL.revokeObjectURL(url);
						});
					})
					.catch((error) => {
						this.modalError = {
							show: true,
							message: "Fehler beim Download der Rücksendebilder",
							error: error,
							title: "Rücksendebilder"
						};
						console.error('Fehler beim Herunterladen der Rücksendebilder:', error);
						this.imageDownloadLoading = false;
					});
		},
	}
}
</script>
<style>
.mikasmallz td {
	padding-top: 0;
	padding-bottom: 0;
	padding-left: 0.75rem !important;

}

.clickable {
	cursor: pointer;
	color: black;
}
</style>